import AccountRegistration from './AccountRegistration';

export default AccountRegistration;